<template>
  <div class="indexVideo">
    <indexBtn
      v-if="index === 1"
      :clickBtn01="clickBtn01"
      :clickBtn02="clickBtn02"
    ></indexBtn>
    <img
      v-if="index === 1"
      class="indexVideo_img"
      src="../../../../public/static/image/img-index.gif"
    />
    <div v-if="index === 2" class="vueplayerContent">
      <div class="vueplayer" style="min-width:320px">
        <vue-core-video-player
          ref="player001"
          title="MPai数据科学平台操作演示"
          :autoplay="false"
          src="static/image/video-001.mp4"
          cover="static/image/introduce/img-introduce-004.png"
        ></vue-core-video-player>
      </div>
      <div class="iconConmtent">
        <Icon
          type="ios-close-circle-outline"
          class="iconStyle"
          @click="iconClose"
        />
      </div>
    </div>
    <div v-if="index === 3" class="vueplayerContent">
      <div class="vueplayer" style="min-width:320px">
        <vue-core-video-player
          ref="player002"
          title="产品介绍"
          :autoplay="false"
          src="static/image/video-002.mp4"
          cover="static/image/introduce/img-introduce-006.png"
        ></vue-core-video-player>
      </div>
      <div class="iconConmtent">
        <Icon
          type="ios-close-circle-outline"
          class="iconStyle"
          @click="iconClose"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexBtn from "./index-btn.vue";
export default {
  components: {
    indexBtn
  },
  data() {
    return {
      index: 1
    };
  },
  methods: {
    clickBtn01() {
      this.index = 2;
    },
    clickBtn02() {
      this.index = 3;
    },
    iconClose() {
      this.index = 1;
    }
  }
};
</script>
<style>
@media screen and (min-width: 768px) {
  .btn-volume {
    display: inherit;
  }
  .btn-pip {
    display: inherit;
  }
  .btn-settings {
    display: inherit !important;
  }
}
@media screen and (max-width: 768px) {
  .setting-control .vue-core-video-player-control:nth-child(2) {
    width: 0px;
  }
  .setting-control .vue-core-video-player-control:nth-child(3) {
    width: 0px;
  }
  .btn-pip {
    display: none !important;
  }
  .btn-settings {
    display: none !important;
  }
}
.vcp-progress-played {
  background-color: #28aae2 !important;
}
.volume-control .btn-control-panel .progress .volume-current {
  background-color: #28aae2 !important;
}
.vcp-switch:after {
  background-color: #28aae2 !important;
}
</style>
<style lang="less" scoped>
.indexVideo {
  width: 100%;
}
.indexVideo_img {
  width: 100%;
}
.vueplayerContent {
  width: 100%;
  min-height: 320px;
  display: flex;
  justify-content: center;
  background-color: #1b1b1b;
}
.iconConmtent {
  width: 100%;
  position: absolute;
  text-align: right;
}
.iconStyle {
  font-size: 50px;
  color: aliceblue;
  margin: 10px;
}
.vueplayer {
  width: 50vw;
  text-align: center;
  background: chartreuse;
}
</style>
